export default __webpack_public_path__ + "static/media/optimistic_ethereum.c432ee1c.svg";